<form [formGroup]="settingsForm">
  <div class="gap-3 d-flex-col">
    <div *ngIf="!exclusiveBuildingType || exclusiveBuildingType === 'WALL'">
      <efp-list-header>
        <ion-label>
          {{ 'SETTINGS.FORMWORK_SETTINGS' | translate }} {{ 'PLAN.WALL' | translate }}
        </ion-label>
      </efp-list-header>

      <div class="gap-3 d-flex-col">
        <div>
          <doka-select
            [label]="'SETTINGS.WALL_FORMWORK' | translate"
            [readonly]="readOnlyMode"
            formControlName="formworkWall"
            [placeholder]="'SETTINGS.SELECT_WALL_FORMWORK' | translate"
            data-test-selector="formworksettings-selection"
            [alert]="
              (isWallFormworkInvalid ? 'FORMWORK_SETTINGS.INVALID_FORMWORK_SELECTED' : '')
                | translate
            ">
            <doka-select-option
              *ngFor="let formwork of formworkSystemService.wallFormworkSystems"
              [label]="'FORMWORK.' + formwork.id | translate"
              [value]="formwork.id"
              attr.data-test-selector="formworksettings-selection-option-{{
                formwork.id
              }}"></doka-select-option>
          </doka-select>
        </div>

        <div *ngIf="wallFavouriteProfile" data-test-selector="formworksettings-wall-favourites">
          <doka-select
            *ngIf="wallFavouriteProfile"
            [label]="'SETTINGS.FAVOURITES_SETTINGS_WALL' | translate"
            [readonly]="readOnlyMode"
            formControlName="wallFavouriteProfile"
            [placeholder]="'SETTINGS.SELECT_WALL_FORMWORK' | translate"
            data-test-selector="formworksettings-selection">
            <doka-select-option
              *ngFor="let favouriteProfile of this.availableFavouriteWallProfiles"
              [value]="favouriteProfile.id"
              attr.data-test-selector="formworksettings-wallFavProfile-select-{{
                favouriteProfile.id
              }}"
              [label]="
                (favouriteProfile.isStandard
                  ? 'FORMWORK.' + favouriteProfile.formworkSystemId
                  : favouriteProfile.name
                ) | translate
              "></doka-select-option>
          </doka-select>
        </div>
      </div>
    </div>

    <div *ngIf="!exclusiveBuildingType || exclusiveBuildingType === 'SLAB'">
      <efp-list-header>
        <ion-label
          >{{ 'SETTINGS.FORMWORK_SETTINGS' | translate }} {{ 'PLAN.SLAB' | translate }}</ion-label
        >
      </efp-list-header>

      <div class="gap-3 d-flex-col">
        <doka-select
          [label]="'SETTINGS.CEILING_FORMWORK' | translate"
          [readonly]="readOnlyMode"
          formControlName="formworkSlab"
          [placeholder]="'SETTINGS.SELECT_CEILING_FORMWORK' | translate"
          data-test-selector="formworksettings-selection"
          [alert]="
            isSlabFormworkInvalid
              ? ('FORMWORK_SETTINGS.INVALID_FORMWORK_SELECTED' | translate)
              : null
          ">
          <doka-select-option
            *ngFor="let formwork of formworkSystemService.slabFormworkSystems"
            [label]="'FORMWORK.' + formwork.id | translate"
            [value]="formwork.id"></doka-select-option>
        </doka-select>

        <doka-select
          *ngIf="slabFavouriteProfile"
          [label]="'SETTINGS.FAVOURITES_SETTINGS_SLAB' | translate"
          formControlName="slabFavouriteProfile"
          [placeholder]="'SETTINGS.SELECT_CEILING_FORMWORK' | translate">
          <doka-select-option
            *ngFor="let favouriteProfile of this.availableFavouriteSlabProfiles"
            [value]="favouriteProfile.id"
            [label]="
              (favouriteProfile.isStandard
                ? 'FORMWORK.' + favouriteProfile.formworkSystemId
                : favouriteProfile.name
              ) | translate
            ">
          </doka-select-option>
          >
        </doka-select>
      </div>
    </div>
  </div>
</form>
